import styled from '@emotion/styled';

export const H1 = styled.h1`
  font-size: 2.6rem;
  font-weight: 900;
`;
